/* GU Wishlist — manager central localStorage */
(function () {
  'use strict';

  var KEY = 'gu_wishlist_v1';
  var EVENT_CHANGE = 'gu:wishlist:change';

  function safeParse(raw) {
    try {
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function read() {
    try {
      return safeParse(localStorage.getItem(KEY));
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function dedupe(list) {
    var seen = {};
    var out = [];
    for (var i = 0; i < list.length; i++) {
      var h = String(list[i] || '').trim();
      if (!h || seen[h]) continue;
      seen[h] = 1;
      out.push(h);
    }
    return out;
  }

  function emit(detail) {
    try {
      document.dispatchEvent(new CustomEvent(EVENT_CHANGE, { detail: detail || {} }));
    } catch (e) {}
  }

  var GuWishlist = {
    KEY: KEY,
    EVENT_CHANGE: EVENT_CHANGE,

    list: function () { return read(); },

    count: function () { return read().length; },

    has: function (handle) {
      if (!handle) return false;
      var list = read();
      return list.indexOf(String(handle)) !== -1;
    },

    add: function (handle) {
      if (!handle) return false;
      var list = read();
      var h = String(handle);
      if (list.indexOf(h) === -1) {
        list.push(h);
        write(dedupe(list));
        emit({ action: 'add', handle: h, count: this.count() });
        return true;
      }
      return false;
    },

    remove: function (handle) {
      if (!handle) return false;
      var list = read();
      var h = String(handle);
      var idx = list.indexOf(h);
      if (idx !== -1) {
        list.splice(idx, 1);
        write(list);
        emit({ action: 'remove', handle: h, count: this.count() });
        return true;
      }
      return false;
    },

    toggle: function (handle) {
      if (!handle) return false;
      return this.has(handle) ? (this.remove(handle), false) : (this.add(handle), true);
    },

    clear: function () {
      write([]);
      emit({ action: 'clear', count: 0 });
    },

    onChange: function (cb) {
      if (typeof cb !== 'function') return function () {};
      document.addEventListener(EVENT_CHANGE, cb);
      return function () { document.removeEventListener(EVENT_CHANGE, cb); };
    }
  };

  window.GuWishlist = GuWishlist;

  function syncCounters() {
    var c = GuWishlist.count();
    var nodes = document.querySelectorAll('[data-gu-wishlist-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = c;
      nodes[i].setAttribute('data-empty', c === 0 ? 'true' : 'false');
    }
  }

  function syncButtons() {
    var btns = document.querySelectorAll('[data-gu-wishlist-btn][data-handle]');
    for (var i = 0; i < btns.length; i++) {
      var h = btns[i].getAttribute('data-handle');
      var active = GuWishlist.has(h);
      btns[i].setAttribute('aria-pressed', active ? 'true' : 'false');
      btns[i].classList.toggle('is-active', active);
      var label = btns[i].querySelector('[data-gu-wishlist-label]');
      if (label) {
        var on = btns[i].getAttribute('data-label-on') || 'En favoritos';
        var off = btns[i].getAttribute('data-label-off') || 'Agregar a favoritos';
        label.textContent = active ? on : off;
      }
    }
  }

  function onBtnClick(e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-gu-wishlist-btn]');
    if (!btn) return;
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    e.preventDefault();
    e.stopPropagation();
    GuWishlist.toggle(handle);
  }

  document.addEventListener('click', onBtnClick, true);
  document.addEventListener(EVENT_CHANGE, function () {
    syncCounters();
    syncButtons();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncCounters(); syncButtons(); });
  } else {
    syncCounters();
    syncButtons();
  }

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) {
      syncCounters();
      syncButtons();
      emit({ action: 'storage', count: GuWishlist.count() });
    }
  });
})();
